import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=207b9183&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"
import style0 from "./Templates.vue?vue&type=style&index=0&id=207b9183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207b9183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207b9183')) {
      api.createRecord('207b9183', component.options)
    } else {
      api.reload('207b9183', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=207b9183&scoped=true&", function () {
      api.rerender('207b9183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/Templates.vue"
export default component.exports